// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__GhdHl","root--md":"Container_root--md__mmhCG"};